<script setup>
import { ref } from 'vue';
import { AnFilledCaretUp, AnFilledCaretDown, BsCheckCircle,
         MdRoundDeleteForever, AkArrowBack } from '@kalimahapps/vue-icons'
// Up and downcomputed, reactive, onMounted,  arrows and a delete with delete confirm

const emit = defineEmits(['up', 'down', 'delete'])

// import { computed } from 'vue';
const props = defineProps({
  content: String,
  stacked: Boolean,
});

const deleteConfirm = ref(false);

function confirmDelete() {
  deleteConfirm.value = !deleteConfirm.value;
}

function deleteConfirmed() {
  deleteConfirm.value = false;
  emit('delete');
}

function moveUp() {
  emit('up');
}

function moveDown() {
  emit('down');
}

</script>

<template>
  <div
      class="controls__container"
      :class="props.stacked ? 'controls__stacked' : ''">
    <div
        class="controls__delete">
      <MdRoundDeleteForever
          class="btn btn__delete"
          :class="{'btn__delete__warning': deleteConfirm}"
          @click="confirmDelete()"
      />
    </div>
    <div
        class="controls__up">
        <AnFilledCaretUp
            class="btn btn__up"
            @click="moveUp()"
            v-if="!deleteConfirm"
        />
        <AkArrowBack
            class="btn btn__up"
            @click="deleteConfirm = false"
            v-else
        />
    </div>
    <div
        class="controls__down">
      <AnFilledCaretDown
          class="btn btn__down"
          @click="moveDown()"
          v-if="!deleteConfirm"
      />
      <BsCheckCircle
          class="btn btn__down"
          @click="deleteConfirmed()"
          v-else
      />
    </div>
  </div>
</template>

<style scoped lang="scss">

.controls {
  &__stacked {
    display: flex;
    flex-direction: column;
  }
  &__container {
    display: flex;
    align-items: center;
  }
  &__delete-confirm {
    background-color: darkslategrey;
  }
  &__delete {
    display: inherit;
    margin-right: .1em;
  }
  &__up {
    display: inherit;
  }
  &__down {
    display: inherit;
  }
}

.btn {
  cursor: pointer;
  width: 1.5rem;
  height: 1.5rem;
  border: none;
  background-color: #007BFF;
  color: white;
  // border-radius: 50%;
  margin: 0px 5px;
  transition: all 0.3s ease;
  font-size: 1em;
  text-align: center;
  line-height: 2.5rem;
  box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.3);
  &:hover {
    background-color: #0056b3;
    box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.5);
  }
  &__warning {
    background-color: red;
    &:hover {
      background-color: red;
    }
  }
  &__delete {
    background-color: darken(red, 20%);
    color: white;
    &:hover {
      background-color: darken(red, 0%);
    }
  }
}
.fade-enter-active {
  transition: all 1.75s ease-out;
}

.fade-leave-active {
  transition: all .25s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

</style>
